import React, { Component } from 'react';
import '../../../public/css/media/_address.scss';
import { history } from '../../store';
import { renderFlagIconRound } from '../../utils/warehouseFlags';
import { krAddress, jpAddress } from './constants'
// import { Link } from 'react-router';

class DashboardAddress extends Component {
  state = {
    tooltipText: {
      "name": false,
      "address": false,
      "city": false,
      "state": false,
      "zip": false,
      "tel": false,
    },
    isKRAddressActive: false,
    isJPAddressActive: false,
  }

  copyClipboard(event, copiedText) {
    var textArea = document.createElement("input");
    textArea.value = copiedText;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand("copy"); // run command to copy selected text to clipboard
      var str = this.state.tooltipText;
      Object.keys(str).map((key) => str[key] = false)
      str[event.target.getAttribute('data-name')] = true;
      this.setState({ tooltipText: str });

      setTimeout(() => {
        Object.keys(str).map((key) => str[key] = false)
        this.setState({ tooltipText: str });
      }, 2500)
    } catch (e) {
      return false;
    }
    textArea.remove();
  }

  renderStateLabel(countryCode) {
    const stateLabel = {
      KR: 'DISTRICT',
      UK: 'COUNTY',
      JP: 'CITY:',
      default: 'STATE'
    }

    return stateLabel[countryCode] || stateLabel.default
  }

  renderWarehouseLabel(countryCode, name) {
    const labels = {
      US: 'United States',
      UK: 'United Kingdom',
      AU: 'Australia',
      KR: 'South Korea',
      JP: 'Japan',
      default: name || 'Warehouse',
    };
    return labels[countryCode] || labels.default;
  };

  renderTranslatedAddress(countryCode, type) {
    const translatedAddresses = {
      KR: krAddress,
      JP: jpAddress
    }
    return translatedAddresses[countryCode][type]
  }

  render(){
    const customer_data = this.props.address.country_code !== 'JP' ? {
      name: `${this.props.first_name} ${this.props.last_name}`,
      line1: `${this.props.address.address_1} ${this.props.address.address_2}\n
        Account No. ${this.props.account_number}`,
      city: this.props.address.city,
      state: this.props.address.state,
      zip: this.props.address.postal_code,
      tel: this.props.address.phone_number
    } : {
      name: `${this.props.first_name} ${this.props.last_name}`,
      line1: `Account No. ${this.props.account_number}`,
      line2: this.props.address.address_2,
      city: this.props.address.state,
      state: this.props.address.city,
      zip: this.props.address.postal_code,
      tel: this.props.address.phone_number
    }
    const trimmedAddressStyle = {
      width: '100%',
      whiteSpace: 'break-spaces',
      fontSize: '14px',
      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
    }
    return(
      <div className="address-box" style={{"marginBottom":"20px"}}>
        {/* {this.props.highlightOregon && this.props.address.id === 6 && <div style={{
          fontSize: '13px',
          color: '#333333',
          marginTop: '10px !important',
          width: '100%',
          alignItems: 'center',
          fontWeight: 600,
          padding: '10px 2px 14px',
          display: 'flex',
        }}>
          <figure className='bounce'>
            <img
              src="https://cdn.shippingcart.com/assets/icon-advisory-20240124090721.svg"
              alt="icon"
              height="28"
              style={{ margin: '-3px 5px 0px 0px' }}
            />
          </figure>
          <div>
            Shipping via USPS? Read our <Link to='/oregon-usps-advisory' style={{fontSize: '14px'}}>service advisory</Link>.
          </div>
        </div>} */}
        <h4 className="sidebar-header">
          <img src={renderFlagIconRound(this.props.address.country_code)} alt="flags" className="flag" />
          {this.renderWarehouseLabel(this.props.address.country_code)}
        </h4>
        <div className="address-table">
        {
          (this.props.address.country_code === 'KR' || this.props.address.country_code === 'JP') && <button
          type="button"
          style={{
            fontSize: '14px',
            color: '#1f6fe7',
            background: 'none',
            border: 'none',
            margin: '10px 0',
            width: '100%',
            textAlign: 'left',
            marginTop: 0
          }}
          onClick={() => {
            this.setState({ isKRAddressActive: !this.state.isKRAddressActive })
          }}
        >
          <span>
            <img
              src='https://cdn.shippingcart.com/assets/translate-icon-20210920091856.png'
              alt="icon"
              height="18"
              style={{ marginRight: '5px' }}
            />
          </span>
          Translate
          </button>
        }
          <table>
            <tbody>
              <tr>
                <td className="field">NAME:</td>
                <td data-name="name" className="value tooltip2">
                  {customer_data.name}
                  <a><span className="tooltiptext" onClick={(event) => this.copyClipboard(event, customer_data.name)} data-name="name">{this.state.tooltipText.name ? "Copied" : "Copy to clipboard"}</span></a>
                </td>
              </tr>
              <tr>
                <td className="field">ADDRESS LINE 1:</td>
                <td data-name="address" className="value tooltip2">
                {
                  this.state.isKRAddressActive || this.state.isJPAddressActive ? <p style={ this.props.unTrimmedAddress ?  {fontSize: '14px'}: trimmedAddressStyle }>
                  { this.renderTranslatedAddress(this.props.address.country_code, 'addressLine1') } <br/>
                  Account No. {this.props.account_number}</p> : <p style={ this.props.unTrimmedAddress ?  {fontSize: '14px', marginBottom: 0}: trimmedAddressStyle }>
                  { this.props.address.country_code !== 'JP' && `${this.props.address.address_1},`} {this.props.address.country_code === 'KR' && this.props.address.address_2}
                  Account No. {this.props.account_number}</p>
                }
                  
                  <a><span className="tooltiptext" onClick={(event) => {
                    if (this.state.isKRAddressActive || this.state.isJPAddressActive) {
                      this.copyClipboard(event, ` ${this.renderTranslatedAddress(this.props.address.country_code, 'addressLine1')} \n
                    Account No. ${this.props.account_number}`)
                      return
                    }
                    this.copyClipboard(event, customer_data.line1)
                    }} data-name="address">{this.state.tooltipText.address ? "Copied" : "Copy to clipboard"}</span></a>
                </td>
              </tr>
              <tr>
                <td className="field">{this.props.address.country_code === 'JP' ? 'PREFECTURE:' :'CITY:'}</td>
                <td data-name="city" className="value tooltip2">
                  {this.state.isKRAddressActive || this.state.isJPAddressActive ? this.renderTranslatedAddress(this.props.address.country_code, 'city') :customer_data.city}
                  <a><span className="tooltiptext" onClick={(event) => {
                    if (this.state.isKRAddressActive || this.state.isJPAddressActive) {
                      this.copyClipboard(event, this.renderTranslatedAddress(this.props.address.country_code, 'city'))
                      return
                    }
                    this.copyClipboard(event, customer_data.city)}
                    } data-name="city">{this.state.tooltipText.city ? "Copied" : "Copy to clipboard"}</span></a>
                </td>
              </tr>
              <tr>
                <td className="field">{this.renderStateLabel(this.props.address.country_code)}</td>
                <td data-name="state" className="value tooltip2">
                  {this.state.isKRAddressActive || this.state.isJPAddressActive? this.renderTranslatedAddress(this.props.address.country_code, 'state'): customer_data.state}
                  <a><span className="tooltiptext" onClick={(event) => {
                    if (this.state.isKRAddressActive || this.state.isJPAddressActive) {
                      this.copyClipboard(event, this.renderTranslatedAddress(this.props.address.country_code, 'state'))
                      return
                    }
                    this.copyClipboard(event, customer_data.state)}} data-name="state">{this.state.tooltipText.state ? "Copied" : "Copy to clipboard"}</span></a>
                </td>
              </tr>
              {this.props.address.country_code === 'JP' && (<tr>
                <td className="field">CHOME:</td>
                <td data-name="city" className="value tooltip2">
                  {this.state.isKRAddressActive ? this.renderTranslatedAddress(this.props.address.country_code, 'chome') : customer_data.line2}
                  <a><span className="tooltiptext" onClick={(event) => {
                    if (this.state.isKRAddressActive) {
                      this.copyClipboard(event, this.renderTranslatedAddress(this.props.address.country_code, 'chome'))
                      return
                    }
                  this.copyClipboard(event, customer_data.line2)}} data-name="city">{this.state.tooltipText.city ? "Copied" : "Copy to clipboard"}</span></a>
                </td>
              </tr>)}
              <tr>
                <td className="field">{this.props.address.country_code === 'UK' ? 'POSTCODE' : 'ZIP'}:</td>
                <td data-name="zip" className="value tooltip2">
                  {customer_data.zip}
                  <a><span className="tooltiptext" onClick={(event) => this.copyClipboard(event, customer_data.zip)} data-name="zip">{this.state.tooltipText.zip ? "Copied" : "Copy to clipboard"}</span></a>
                </td>
                
              </tr>
              <tr className="last">
                <td className="field">TEL #:</td>
                <td data-name="tel" className="value tooltip2">
                  {customer_data.tel}
                  <a><span className="tooltiptext" onClick={(event) => this.copyClipboard(event, customer_data.tel)} data-name="tel">{this.state.tooltipText.tel ? "Copied" : "Copy to clipboard"}</span></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {this.props.address.country_code === 'JP' && this.props.unTrimmedAddress && <div style={{border: '1px solid #E2E2E2', borderRadius: '5px', display: 'flex', backgroundColor: '#E5F1FB', padding: '10px', flexDirection: 'column'}}>
          <div style={{marginBottom: '10px', fontSize: '16px', fontWeight: 600, display: 'flex'}}>
            <img
            src='https://cdn.shippingcart.com/assets/information_(2)-20230306045336.svg'
            alt="icon"
            height="22"
            style={{ marginRight: '5px' }}
            />
            Did you know?
          </div>
          <div style={{fontSize: '14px', color: '#707070'}}>
            Some websites may ask for your full name in Katakana or Hiragana.
          </div>
          <span style={{ color: '#0375D9', fontWeight: 600, cursor: 'pointer', marginTop: '5px'}} onClick={() => history.push('/warehouse-address-guide-jp')}>
            Here’s how.
          </span>
        </div>}
      </div>
    )
  }
}
export default DashboardAddress;



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/DashboardAddress.js
 **/